import { gql } from '@apollo/client'

export const ADD_USER = gql`
  mutation AddUser($input: AddUserInput!) {
    addUser(input: $input) {
      user {
        firstName
        lastName
      }
    }
  }
`
